import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/ja';
import 'dayjs/locale/ko';
import 'dayjs/locale/nl';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/ru';
import 'dayjs/locale/zh-cn';
import { getLanguage } from '@citrite/translate';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
export function getIs24Hr(timeFormat) {
  dayjs.extend(localeData);
  dayjs.extend(relativeTime);
  dayjs.extend(localizedFormat);
  if (timeFormat) {
    var expandTimeFormat = timeFormat;
    try {
      expandTimeFormat = dayjs().localeData().longDateFormat(timeFormat);
    } catch (err) {
      //If calling function passes in an unrecognised format, longDateFormat throws an error
    }
    return expandTimeFormat.startsWith('H');
  }
  var time = new Date(2019, 1, 1, 13, 0, 0, 0);
  var timeString = dayjs(time).locale(getLanguage()).format('LT');
  return timeString.includes('13');
}